// This component is used to insert HTML content into the DOM and handle the execution of any scripts within that content.
import React, { useEffect, useRef } from 'react';

const InnerHTML = ({ content, containerClass }) => {
  const containerRef = useRef();

  useEffect(() => {
    containerRef.current.querySelectorAll("script").forEach(script => {
      const newScript = document.createElement("script");
      newScript.textContent = script.textContent;
      document.body.appendChild(newScript);
      script.remove();
    });
  }, [content]);

  return <div
    ref={ containerRef }
    className={ containerClass }
    dangerouslySetInnerHTML={{ __html: content }}
  />;
};

export default InnerHTML;
